export default {
  Summary: "0",
  LocationSummary: "1",
  DailyMonitoring: "2",
  ProgressChart: "3",
  PostingSummary: "4",
  SampleStats : "5",
  LabStats : "6",
  SampleAnomalies : "7",
  SampleSummary : "8"
};